import {AdminCompanyPurchaseDTO} from '../../../../api/data-contracts'
import moment from 'moment'
import {useSelector} from 'react-redux'
import {ProductTypeEnum, UserTypeAuthorizationsEnum} from '../../../../apiClient/enums'
import _ from 'lodash'
import {getAdminState} from '../../../../redux/adminSlice'
import clsx from 'clsx'
import BasePopup, {PopupProvides} from '../../../common/popup/BasePopup'
import UpsertPurchase from './UpsertPurchase'
import AuthorizedComponent from '../../../common/auth/AuthorizedComponent'
function AdminCompanyPurchases(props: {load?: () => void}) {
  const adminState = useSelector(getAdminState)

  function getSortedPurchases() {
    return _.orderBy(
      adminState.company?.purchases ?? [],
      [(o) => (o.product?.productTypeId === 3 ? 0 : 1), (o) => new Date(o.firstPurchaseTime ?? '')],
      ['asc', 'desc']
    )
  }

  function getRowColor(productTypeId: number) {
    if (productTypeId === ProductTypeEnum.Paket) {
      return 'bg-success'
    } else if (productTypeId === ProductTypeEnum.Ek_Çözüm) {
      return 'bg-primary'
    } else {
      return 'bg-warning'
    }
  }

  return (
    <>
      <div className='row g-5 mb-5'>
        <AuthorizedComponent auth={UserTypeAuthorizationsEnum.Admin_Panel_Company_Purchase_Start}>
        <BasePopup
          title='Yeni Ürün Satışı'
          size='xl'
          modalOpener={<button className='btn btn-sm btn-primary'>Yeni Ürün Satışı</button>}
        >
          {(providers: PopupProvides) => (
            <UpsertPurchase purchase={null} close={providers.handleClose} load={props.load} />
          )}
        </BasePopup>
        </AuthorizedComponent>

        {getSortedPurchases().map((purchase: AdminCompanyPurchaseDTO) => (
          <div key={purchase.purchaseId} className='col-xl-4 col-lg-6 col-md-6'>
            <div
              className={clsx('card', {
                'border border-danger': !purchase.isActive,
              })}
            >
              <div
                className={clsx(
                  'card-header',
                  'bg-opacity-25',
                  getRowColor(purchase.product?.productTypeId ?? 0)
                )}
              >
                <div className='card-title'>
                  <h3 className='fw-bold fs-4 mb-0'>{purchase.product?.description}</h3>
                </div>
              </div>
              <div className='card-body'>
                <div className='d-flex flex-column'>
                  <div className='d-flex justify-content-between mb-3'>
                    <span className='fw-bold text-gray-600'>Başlangıç:</span>
                    <span className='text-dark'>
                      {moment(purchase.firstPurchaseTime).format('DD.MM.yyyy')}
                    </span>
                  </div>
                  {purchase.finishTime && (
                    <div className='d-flex justify-content-between mb-3'>
                      <span className='fw-bold text-gray-600'>Bitiş:</span>
                      <span className='text-dark'>
                        {moment(purchase.finishTime).format('DD.MM.yyyy')}
                      </span>
                    </div>
                  )}
                  <div className='d-flex justify-content-between mb-3'>
                    <span className='fw-bold text-gray-600'>Toplam:</span>
                    <span className='text-dark fw-bold'>
                      {Math.round(purchase.totalPayment ?? 0)} ₺
                    </span>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <span className='fw-bold text-gray-600'>Gelecek:</span>
                    <span className='text-dark fw-bold'>
                      {Math.round(purchase.totalDuePayment ?? 0)} ₺
                    </span>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <span className='fw-bold text-gray-600'>Borç:</span>
                    <span className='text-danger fw-bold'>
                      {Math.round(purchase.totalDebt ?? 0)} ₺
                    </span>
                  </div>
                  <div className='d-flex justify-content-end mt-auto pt-3'>
                    <BasePopup
                      title={
                        adminState.company?.company?.shortName +
                        ' - ' +
                        (purchase.purchaseId ? ' Satış Düzenle' : ' Yeni Satış Ekle')
                      }
                      size='xl'
                      fullscreen={true}
                      modalOpener={<button className='btn btn-sm btn-primary'>Düzenle</button>}
                    >
                      {(providers: PopupProvides) => (
                        <UpsertPurchase
                          purchase={purchase}
                          close={providers.handleClose}
                          load={props.load}
                        />
                      )}
                    </BasePopup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <div className='table-responsive'>
        <>
          <div>
            <BootstrapTable
              keyField='purchaseId'
              data={getSortedPurchases()}
              columns={mainTableColumns}
              classes='table table-rounded gt-3 gs-3'
              headerClasses='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 bg-info bg-opacity-25'
            />
          </div>
        </>
      </div> */}
    </>
  )
}

export default AdminCompanyPurchases
